import React from "react"
import autobind from "class-autobind"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody, Avatar } from "material-ui"
import Table from "../../../../components/common/Table"
import strings from "../../../../localization/strings"
import { IWorkforceAssessmentDashboardPositionSummary } from "../../../../models/data/dashboard/WorkforceAssessment/WorkforceAssessmentDashboard"
import * as utils from "../../../../helpers/utils"
import AccountStore from "../../../../stores/AccountStore"

declare global {
    interface Window {
        Intercom: any
    }
}
interface IState{}

interface IProps {
    items: IWorkforceAssessmentDashboardPositionSummary[]
    onRowClick: any
}

export default class WorkforceAssessmentPositionsTable extends React.Component<IProps, IState> {    
    constructor(props) {
        super(props)
        this.state = {
        }
        autobind(this)
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        const { items } = this.props;
        if (!items) {
            return <div>No data available</div>;
        }

        return (
            <Table items={items} readonly>
                <TableHeader>
                    <TableRow>
                        <TableRowColumn style={{width: 50}} />
                        <TableHeaderColumn style={{ width: 250, }}>
                            {strings.Name}
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: 50, }}>
                            {strings.FillRate}
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: 50 }} >
                            Core
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: 50 }} >
                            Float
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: 50 }} >
                            Per Diem
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: 50 }} >
                            Agency
                        </TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody showRowHover={true} deselectOnClickaway={false}>
                    {items.map((row, i) => {
                        const position = AccountStore.CurrentAccount.PositionDefinitions.find(item => item.BasePositionId == row.BasePositionId)

                        return (
                            <TableRow key={row.BasePositionId}>
                                <TableRowColumn style={{width: 50}}>
                                    <Avatar backgroundColor={position.Color} size={30} />
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 250 }}>
                                    {row.PositionName}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {utils.toPercentage(row.ScheduleBudgetInfo.FillRateInfo.FillRate)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {utils.toPercentage(row.ScheduleBudgetInfo.WorkTypeInfo.Core)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {utils.toPercentage(row.ScheduleBudgetInfo.WorkTypeInfo.Float)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {utils.toPercentage(row.ScheduleBudgetInfo.WorkTypeInfo.PerDiem)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {utils.toPercentage(row.ScheduleBudgetInfo.WorkTypeInfo.Agency)}
                                </TableRowColumn>
                            </TableRow>
                        )
                    })}
                </TableBody>                
            </Table>
        )
    }
}